import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { UserSessionService } from '../services/authentication/user-session.service';

@Injectable()
export class PermissionInterceptor implements HttpInterceptor {
  constructor(private userSession: UserSessionService) {}

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(httpRequest)
      .pipe(
        catchError((err) => {
          return throwError(() => err);
        })
      )
      .pipe(
        map<HttpEvent<any>, any>((res: HttpEvent<any>) => {
          if (res instanceof HttpResponse) {
            const isImpersonateMode = res.headers.has('x-imp');
            if (isImpersonateMode && +isImpersonateMode > 0)
              this.userSession.setIsImpersonateMode(true);
            else this.userSession.setIsImpersonateMode(false);
          }
          return res;
        })
      );
  }
}

export const HttpPermissionInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: PermissionInterceptor, multi: true },
];
